<template>
    <div class="baseButton-container">
        <el-button
            v-bind="$attrs"
            :class="type"
            :loading="loading"
            @click="handleClick"
        >
            <slot></slot>
        </el-button>
    </div>
</template>

<script lang="ts" setup>
/**
 * 基础按钮组件
 * 场景：符合设计稿的多种按钮样式
 * 可选样式：type = 'primary' || 'cancel || 'other
 * */
defineProps({
    type: {
        type: String,
        default: 'primary'
    },
    loading: {
        type: Boolean,
        default: false
    }
});

const emits = defineEmits(['click']);
const handleClick = () => {
    emits('click');
};
</script>

<style lang="scss" scoped>
.baseButton-container {
    :deep(.el-button) {
        border: none;
        height: 38px;
        border-radius: 8px;
        font-size: 13px;
        padding: 0 18px;
        &.is-disabled {
            opacity: 0.3 !important;
        }
        &.primary {
            background: #2888ff;
            span {
                color: #fff;
            }
            &:hover {
                background-color: #4598ff;
            }
        }
        &.cancel {
            background: rgba(194, 204, 217, 0.3);
            span {
                color: #303133;
            }
            &:hover {
                background-color: rgba(194, 204, 217, 0.2);
            }
        }
        &.other {
            background: rgba(40, 136, 255, 0.16);
            span {
                color: #2888ff;
            }
            &:hover {
                background: rgba(40, 136, 255, 0.22);
            }
        }
    }
}
</style>
